"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sdk = void 0;
const services = __importStar(require("./services"));
const methods = __importStar(require("./methods"));
const typings = __importStar(require("@monorepo/typings/sdk"));
class Sdk extends services.CustomEmitter {
    mount;
    api;
    session;
    env;
    async;
    sync;
    methods;
    app = typings.Projects.titles.crossmark;
    constructor(opts) {
        super();
        if (opts?.project)
            this.app = opts?.project;
        this.env = new services.Env();
        this.api = new services.Api(this);
        this.session = new services.Session(this);
        this.mount = new services.Mount(this);
        this.async = new methods.Async(this);
        this.sync = new methods.Sync(this);
        this.methods = Object.assign({}, this.async, this.sync);
        new services.CustomEvents(this);
    }
}
exports.Sdk = Sdk;
